
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "Form2",
})
export default class extends Vue {
  @Watch("formmodel2", { deep: true })
  onChildChanged(val: string) {
    this.$emit("get-form2-value", val);
  }
  private formmodel2 = {
    checked1: false,
    checked2: false,
    checked3: false,
    checked4: false,
  };
}
